import React, { FC, PropsWithChildren, RefObject, forwardRef, useEffect, useRef, useState } from 'react';
import { setClass } from '@utils';

interface DateTimePickerProp {
  left: number;
  top: number;
  bottom: number;
}

export const MeetingDetailedInformationMembersList = forwardRef<HTMLDivElement, PropsWithChildren<DateTimePickerProp>>(({
  left, top, children, bottom, 
}, ref: RefObject<HTMLDivElement>) => {
  const [showAbove, setShowAbove] = useState<boolean>(false);
  const [showList, setShowList] = useState<boolean>(false);
  const listRef = ref;

  useEffect(() => {
    if (listRef.current) {
      setShowAbove(listRef.current.getBoundingClientRect().top + top + listRef.current.clientHeight > (window.innerHeight || document.documentElement.clientHeight));
      setShowList(true);
    }
  }, []);

  const getStyle = () => {
    if (showList) {
      return showAbove ? { left, bottom } : { left, top }
    }
    return {};
  };

  return (
    <div
      ref={listRef}
      style={getStyle()}
      className={setClass('meeting-members-list', !showList && 'hidden')}
    >
      <div className="items">
        {children}
      </div>
    </div>
  );
});
